{
  "app": {
    "approveFailed": "批准失败：{{error}}",
    "archive": "归档",
    "archiveFailed": "归档失败：{{error}}",
    "archiveThreadFailed": "归档失败：{{error}}",
    "archiveThreadMessage": "“{{title}}”将从侧边栏隐藏。对话历史会保留在磁盘上。",
    "archiveThreadMidTurn": "无法在回合进行中归档对话 —— 请等待其完成",
    "archiveThreadTitle": "归档对话？",
    "bulkApproveAccepted": "✓ 已接受 {{n}} 个 · {{parts}}",
    "bulkApproveFailed": "批量批准：{{total}} 个中有 {{failed}} 个失败",
    "bulkApproveToCards": "{{n}}→卡片",
    "bulkApproveToOpen": "{{n}}→OPEN",
    "cardArchived": "已归档 {{id}}",
    "cardDeleted": "已删除 {{id}}",
    "cardDeletedBrokenReferences": "已删除 {{id}} —— 以下卡片中存在失效引用：{{refs}}",
    "cardDeletedBrokenRefs": "已删除 {{id}}；失效引用：{{refs}}",
    "cardMarkedStatus": "已将 {{id}} 标记为 {{status}}",
    "cardSaved": "已保存 {{id}}",
    "cardStatusCleared": "已清除 {{id}} 的状态",
    "cardWrittenBrokenRefs": "{{id}} 已写入，但存在失效引用：{{refs}}",
    "cardsMarkedStale": "{{id}} 已重新断言 —— {{n}} 个依赖卡片被标记为已过期",
    "cardsUndone": "已撤销 {{n}} 个卡片",
    "deleteFailed": "删除失败：{{error}}",
    "discard": "放弃",
    "discardChangesMessage": "打开的卡片中有未保存的编辑。继续将丢失这些更改。",
    "discardChangesTitle": "放弃未保存的更改？",
    "generateFailed": "生成失败：{{error}}",
    "markStatusFailed": "标记状态失败：{{error}}",
    "packBlank": "空白",
    "packChanged": "包已切换为 {{pack}}",
    "projectCreated": "已创建项目“{{name}}”",
    "projectDeleted": "已删除项目",
    "projectImported": "已导入“{{name}}”",
    "proposalApproved": "已批准 {{id}} → {{kind}}",
    "proposalRejected": "已拒绝 {{id}}",
    "proposalRejectedMarked": "已拒绝 {{id}} · 标记了 {{n}} 个卡片",
    "rejectFailed": "拒绝失败：{{error}}",
    "renameProjectFailed": "重命名项目失败：{{error}}",
    "saveFailed": "保存失败：{{error}}",
    "setModelPreferenceFailed": "设置模型偏好失败：{{error}}",
    "threadArchived": "对话已归档",
    "threadTitleAnswer": "回答",
    "threadTitleDiscuss": "讨论",
    "undo": "撤销",
    "undoDeleteFailed": "撤销：{{total}} 个中有 {{failed}} 个删除失败",
    "untitled": "未命名",
    "cardsMarkedStaleFirst": "你刚改了决定 {{id}}——{{n}} 张依赖它的卡片已标记待检视。这就是 Draftlize 和聊天窗口的区别：你的思考会保持自洽。"
  },
  "cardBody": {
    "jumpTo": "跳转到 {{id}}"
  },
  "cardPeek": {
    "approveTooltip": "应用编辑并提升为 {{kind}}",
    "approving": "批准中…",
    "archive": "归档",
    "archiveTooltip": "从视图中软隐藏 · wikilink 仍可解析",
    "brokenRefs": "失效引用：",
    "brokenRefsTooltip": "这些 wikilink 目标在项目中不存在。",
    "byAgent": "由 agent 创建",
    "byYou": "由你创建",
    "bySuggested": "AI 建议待审",
    "byRevised": "由你修订",
    "closeHint": "Esc · 点击外部关闭",
    "closePeekAria": "关闭速览",
    "confirmDelete": "永久删除 {{id}}？",
    "confirmReject": "拒绝并删除 {{id}}？",
    "copy": "复制",
    "customKindPlaceholder": "自定义种类",
    "deleteReasonPlaceholder": "原因（可选，会显示在已删除视图中）",
    "deleting": "删除中…",
    "editLabel": "编辑",
    "fieldBody": "正文",
    "fieldKind": "种类",
    "fieldPack": "包",
    "fieldTitle": "标题",
    "history": "历史",
    "historyTooltip": "查看此卡片的每个修订",
    "jumpTo": "跳转到 {{id}}",
    "kindOther": "其他…",
    "markStatusTooltip": "标记此卡片的实现状态",
    "implTimelineLabel": "实现进度",
    "implTimeline": {
      "proposed": {
        "label": "已提出",
        "note": "讨论中确定——还没动代码。"
      },
      "building": {
        "label": "构建中",
        "note": "coding agent 正在实现这张卡。"
      },
      "built": {
        "label": "已实现",
        "note": "已落地——实现与这张卡一致。"
      },
      "drift_detected": {
        "label": "已漂移",
        "note": "这张卡在标记 built 之后被修改——实现可能已经过期。"
      }
    },
    "packPlaceholder": "（无）",
    "reject": "拒绝",
    "saveAndApprove": "保存并批准 → {{kind}}",
    "saveChangesTooltip": "保存更改",
    "saveGapTooltip": "保存这个 gap（仍待批准）",
    "saving": "保存中…",
    "seeHistoryOfDeleted": "查看已删除 {{id}} 的历史",
    "stale": "· 已过期",
    "statusBuilding": "构建中",
    "statusBuilt": "已构建",
    "statusClear": "（清除）",
    "statusDriftDetected": "已检测到偏移",
    "statusProposed": "已提议",
    "unarchive": "取消归档",
    "unarchiveTooltip": "恢复到视图中（默认时间 / 状态视图）",
    "unsaved": "· 未保存",
    "uriTooltip": "在 Claude Code 中粘贴 @<此 URI> 即可固定为上下文",
    "yesDelete": "确认删除",
    "yesReject": "确认拒绝"
  },
  "graphShare": {
    "title": "分享卡片",
    "building": "正在生成分享卡片……",
    "savePng": "保存图片",
    "copyLink": "复制链接",
    "copied": "已复制",
    "error": "生成失败：{{error}}",
    "sizeHint": "1080×1440 · 适合朋友圈",
    "statsCards_one": "{{count}} 张卡片",
    "statsCards_other": "{{count}} 张卡片",
    "statsDecisions_one": "{{count}} 个决策",
    "statsDecisions_other": "{{count}} 个决策",
    "tagline": "用 Draftlize 孵化你的想法"
  },
  "cardRow": {
    "brokenRefs": "失效引用：",
    "brokenRefsTooltip": "这些 wikilink 目标在项目中不存在。",
    "byAgent": "由 agent 创建",
    "byYou": "由你创建",
    "bySuggested": "AI 待审核",
    "byRevised": "你已修订",
    "implStatus": {
      "building": {
        "label": "构建中",
        "tooltip": "进行中"
      },
      "built": {
        "label": "✓ 已构建",
        "tooltip": "实现已交付"
      },
      "drift_detected": {
        "label": "⚠ 已偏移",
        "tooltip": "实现之后规格已变更。请重新构建或重新标记。"
      },
      "proposed": {
        "label": "已提议",
        "tooltip": "已确认待构建"
      }
    },
    "jumpTo": "跳转到 {{id}}",
    "less": "— 收起",
    "mcpRecentTooltip": "过去 24 小时内被外部 MCP 客户端读取",
    "more": "+ 展开",
    "pinManualTooltip": "由用户手动排布",
    "pinResetTooltip": "你把它放在这里 · 点击可重置为 LLM 排布",
    "seeHistoryOfDeleted": "查看已删除 {{id}} 的历史",
    "stale": "· 已过期",
    "unknownCard": "未知卡片"
  },
  "cards": {
    "addAFrame": "添加视图",
    "addCardsFirst": "请先添加卡片",
    "addFrameMenu": "添加视图…",
    "allCards": "所有卡片",
    "buildingExport": "正在生成导出文件…",
    "cardCount_one": "{{count}} 张卡片",
    "cardCount_other": "{{count}} 张卡片",
    "cardsLandHere": "卡片会出现在这里。",
    "cardsLandHereBody": "agent 写下卡片时，会出现在这一栏。大约 6 张卡片后，系统会帮你把它们整理进一个视图。",
    "collecting": "收集中…",
    "collectingBody_one": "已有 {{count}}/6 张卡片。继续聊；满 6 张后，agent 就能给出结构建议。",
    "collectingBody_other": "已有 {{count}}/6 张卡片。继续聊；满 6 张后，agent 就能给出结构建议。",
    "computingLayout": "正在计算布局…",
    "deleteFrame": "删除视图",
    "deleteFrameConfirm": "删除视图“{{name}}”？该视图的卡片分配将被移除；卡片本身不受影响。",
    "deleted": "已删除",
    "deletedCount_one": "{{count}} 张已删除",
    "deletedCount_other": "{{count}} 张已删除",
    "errDelete": "删除",
    "errLoadFrame": "加载视图",
    "errLoadFrames": "加载视图",
    "errOverride": "覆盖",
    "errRename": "重命名",
    "errReset": "重置",
    "exportFailed": "导出失败",
    "exportHint": "下载 .zip — 卡片、删除记录、完整历史、对话",
    "exporting": "导出中…",
    "frameMenu": "视图菜单",
    "gapCountHint": "尚无卡片的 MECE 必填节点",
    "gapCount_one": "{{count}} 个 gap",
    "gapCount_other": "{{count}} 个 gap",
    "generateDoc": "生成 · 设计文档",
    "generateDocHint": "生成一份设计文档",
    "generating": "生成中…",
    "hidden": "已隐藏",
    "hiddenHint": "已从此视图排除 — 拖到某个节点可恢复，或点击 📌 让 LLM 决定",
    "lensStatus": "状态",
    "lensStatusSubtitle": "按类型分组 · decision → statement → gap → …",
    "lensTime": "时间",
    "lensTimeSubtitle": "最新优先 · 默认",
    "llmCategorized": "由 LLM 分类",
    "noCardsYet": "还没有卡片。agent 写下第一张后，会显示在这里。",
    "noLensHint": "无视图 — 所有卡片的平铺列表",
    "nothingToExport": "暂无可导出的内容",
    "readyBody_one": "你已有 {{count}} 张卡片。选择一个视图来整理它们 — agent 可以根据你写下的内容给出建议，你也可以选用模板。",
    "readyBody_other": "你已有 {{count}} 张卡片。选择一个视图来整理它们 — agent 可以根据你写下的内容给出建议，你也可以选用模板。",
    "readyToOrganize": "可以整理了",
    "rename": "重命名",
    "renameFramePrompt": "重命名视图",
    "seeDeletedHint": "查看已删除的卡片",
    "showArchived": "显示已归档",
    "showArchivedHint": "软隐藏的卡片（如测试/无用卡片）— 仍保留在数据库中以便 wikilink 解析，默认在视图中隐藏",
    "staleDocsAria_one": "{{count}} 份已过期的文档",
    "staleDocsAria_other": "{{count}} 份已过期的文档",
    "staleDocsHint_one": "{{count}} 份已保存的文档可能已过期 — 打开查看",
    "staleDocsHint_other": "{{count}} 份已保存的文档可能已过期 — 打开查看",
    "unplaced": "未归位",
    "unplacedHint": "没有明确归类 — 想好后拖到某个节点",
    "viewHidden_one": "查看已隐藏（{{count}}）",
    "viewHidden_other": "查看已隐藏（{{count}}）",
    "staleDemoPrompt": "试试核心机制：改一下这个决定，看依赖它的卡片自动标记待检视。",
    "staleDemoCta": "试一下",
    "staleDemoDismiss": "关闭"
  },
  "columnResizer": {
    "resizeHandle": "调整讨论面板宽度。方向键微调，按 Shift 大幅调整，双击或回车恢复默认。",
    "showCards": "显示卡片"
  },
  "common": {
    "back": "返回",
    "cancel": "取消",
    "close": "关闭",
    "delete": "删除",
    "edit": "编辑",
    "loading": "加载中…",
    "refresh": "刷新",
    "retry": "重试",
    "save": "保存"
  },
  "computed": {
    "badgeTooltip": "此卡片上的某个数值已由 python_compute 沙箱运行验证。打开卡片可查看代码。",
    "durationMs": "{{ms}} 毫秒",
    "exitCode": "退出码 {{code}}",
    "inputs": "输入：",
    "label": "π 已计算",
    "runNumber": "运行 #{{id}}",
    "stdout": "标准输出"
  },
  "confirm": {
    "confirm": "确认"
  },
  "dcard": {
    "stale": "已过期"
  },
  "deleted": {
    "backToCards": "返回卡片",
    "byAgent": "由 AGENT",
    "byFs": "由文件系统",
    "byYou": "由你",
    "daysAgo": "{{count}} 天前",
    "emptyState": "暂无已删除的卡片",
    "groupAgentEdit": "Agent 删除",
    "groupFsDelete": "文件系统删除",
    "groupOther": "其他",
    "groupRejectedGap": "已驳回的 gap",
    "groupResolvedGap": "已解决的 gap",
    "groupUserDelete": "你删除",
    "heading": "已删除",
    "viewFullHistory": "查看完整历史",
    "yesterday": "昨天"
  },
  "discussion": {
    "addToCards": "加入卡片",
    "addToOpen": "加入 OPEN",
    "agentDecidesHint": "由 agent 决定何时写卡片",
    "answerNow": "立即解答",
    "attachRefTooltip": "附加一个项目 ref",
    "attachedChipTooltip": "已作为项目 ref 附加 · 点击 × 移除自动提及",
    "attachedRemoveAria": "移除 {{name}}",
    "bulkAcceptAll": "全部采纳（{{parts}}）",
    "bulkAddAllToCards": "全部加入卡片（{{count}}）",
    "bulkAddAllToOpen": "全部加入 OPEN（{{count}}）",
    "bulkApproveAllTooltip": "采纳此批次中的所有提议",
    "bulkBreakdownAllQuestions": "（全部为问题）",
    "bulkBreakdownAllSettled": "（全部已定）",
    "bulkBreakdownMixed": "（{{questions}} 个问题，{{other}} 个其他）",
    "bulkExpandTooltip": "逐条展示每个提议，便于你逐一处理",
    "bulkPartCards": "{{count}}→卡片",
    "bulkPartOpen": "{{count}}→OPEN",
    "bulkProposalsCount": "{{count}} 个提议",
    "bulkProposalsExpanded": "{{count}} 个提议 · 已展开",
    "bulkRejectAllTooltip": "驳回此批次中的所有提议",
    "clickToDismiss": "点击关闭",
    "collapse": "收起",
    "composerDropPlaceholder": "拖放以作为项目 ref 附加",
    "composerPlaceholder": "与 agent 一起把想法说出来…",
    "convertItemsMany": "↳ 转换 {{count}} 个条目 → OPEN",
    "convertItemsOne": "↳ 转换 {{count}} 个条目 → OPEN",
    "convertTooltip": "对这一条消息运行限定范围的拆解式提炼，并把条目呈现到 OPEN 中。",
    "converting": "转换中…",
    "discuss": "讨论",
    "dismiss": "驳回",
    "dismissAll": "全部驳回",
    "distillButton": "提炼 ⌘D",
    "distillTooltip": "回顾本次对话，提出本应写下的卡片",
    "distilling": "提炼中…",
    "emptyBody": "agent 会自由交谈、深入追问，并在时机明朗时写下卡片。你随时可以在结束时进行提炼，补全遗漏的内容。",
    "emptyTitle": "从一个模糊的想法开始。",
    "expand": "展开",
    "headerTitle": "对话",
    "jumpToLatestTooltip": "跳到最新消息",
    "newReplyMany": "↓ {{count}} 条新回复",
    "newReplyOne": "↓ {{count}} 条新回复",
    "openProjectFirst": "请先打开一个项目",
    "pinnedApproveQuestionTooltip": "问题无法被采纳 — 写下答案后再归档",
    "pinnedApproveTooltip": "提升 → {{kind}}（其建议类型）",
    "pinnedBadgeAnswering": "✦ 解答中 {{id}}",
    "pinnedBadgeDiscussing": "✦ 讨论中 {{id}}",
    "pinnedRejectTooltip": "驳回 — 删除该 gap 并将关联块标记为已驳回",
    "pinnedResolveTooltip": "停止将对话引向该 gap（gap 仍保留在 Gap Ledger 中）",
    "pinnedWhyPrefix": "原因：",
    "postResolveDismiss": "忽略",
    "postResolvePrefix": "已结束",
    "postResolveSuffix": "。本次讨论是否暴露了新的 gap？",
    "queuedCancelAria": "取消已排队的发送",
    "queuedChipTooltip": "已排队 — 当前轮次结束后发送 · 点击 × 取消",
    "queuedImageMany": "（{{count}} 张图片）",
    "queuedImageOne": "（{{count}} 张图片）",
    "queuedPrefix": "↵ 已排队：",
    "resolve": "结束",
    "roleAgent": "✦ AGENT · {{time}}",
    "roleYou": "你 · {{time}}",
    "runAudit": "运行审查",
    "sandboxRunning": "🐍 sandbox 跑代码中",
    "sendButtonQueue": "排队",
    "sendButtonQueueTooltip": "排队（↵）— 当前轮次结束后发送",
    "sendButtonSend": "发送",
    "sendButtonSendTooltip": "发送（↵）· ⇧↵ 换行",
    "sendButtonStop": "停止",
    "sendButtonStopAria": "停止进行中的轮次",
    "sendButtonStopTooltip": "停止 — 中断进行中的轮次",
    "thinkingChars": "{{count}} 字符",
    "thinkingLabel": "✦ 思考 · {{time}}",
    "thinkingPlaceholder": "✦ 思考中",
    "tierChipTooltip": "档位：{{tier}}{{suffix}} — 点击更改",
    "tierCustomLabel": "自定义：",
    "tierDefaultBadge": "默认",
    "tierEffortHeading": "推理强度",
    "tierEffortIgnoredTooltip": "快速模式已开启 — 请求时会忽略推理强度。",
    "tierFastMode": "快速模式",
    "tierFastModeTooltip": "完全跳过思考。以推理质量换取首字节延迟。",
    "tierModelsHeading": "模型",
    "tierResetToDefault": "恢复默认",
    "tierVisionStickyNote": "此对话含有图片。服务器会自动路由到支持视觉的模型，使此前的轮次保持可读，无视选择。",
    "tierVisionStickyTooltip": "视觉锁定：此对话含有图片，服务器会无视选择，路由到支持视觉的模型。点击仍可更改。",
    "toolApproveQuestionTooltip": "作为待解决的问题加入 OPEN QUESTIONS",
    "toolApproveTooltip": "作为 {{kind}} 加入卡片",
    "toolApprovedSummary": "✓ 已采纳 → {{id}}（{{kind}}）",
    "toolDiscussQuestionTooltip": "开启一个对话，与 agent 一起解答此问题",
    "toolDiscussTooltip": "开启一个对话，在采纳前打磨此提议",
    "toolJumpTooltip": "点击跳转到 {{id}}",
    "toolRejectTooltip": "驳回 — 删除该提议并将关联块标记为已驳回",
    "toolToggleTooltip": "点击展开/收起完整输入",
    "truncatedLabel": "⚠ 已截断 · 达到 max_tokens — 回复被中断",
    "truncatedTooltip": "模型因达到 max_tokens 而停止。请调高 DRAFTLIZE_MAX_TOKENS，或让 agent 继续。",
    "untitledGap": "(未命名 gap)",
    "untitledQuestion": "(未命名问题)",
    "uploadFailed": "上传失败：{{error}}",
    "uploading": "正在上传 {{count}}…",
    "working": "处理中…"
  },
  "distill": {
    "blocksPrefix": "阻塞:",
    "cardsSection": "卡片 · {{selected}} / {{total}}",
    "cardsSectionHint": "提炼内容 — 提交时通过 write_card 直接写入",
    "commit": "提交 {{count}}",
    "extractedSoFar": "已提取 {{count}} 个条目",
    "failed": "提炼失败: {{message}}",
    "gapsSection": "gap · {{selected}} / {{total}}",
    "gapsSectionHint": "待办项 — 提交时通过 propose_card 呈现在 OPEN",
    "headerHint": "卡片：直接写入 · gap：呈现在 OPEN",
    "heading": "提炼对话",
    "hintAudit": "以审查视角对项目做全局 gap 盘点 · 输出多为带优先级的 gap",
    "hintDecompose": "把 agent 的结构化产物(清单 / 层级)拆解为原子条目",
    "hintRescue": "捕捉这个对话中遗漏的提炼内容 · 略偏向 gap",
    "modeAudit": "审查",
    "modeDecompose": "拆解",
    "modeRescue": "抢救",
    "nothingToExtract": "没有可提取的内容。",
    "nothingToExtractHint": "这个对话没有产生新的提炼内容或待办项。要么它仍处于探索阶段，要么 agent 已在过程中捕捉了它。",
    "reading": "读取中…",
    "scanning": "正在扫描对话",
    "scanningHint": "来自对话的卡片 + gap",
    "selectedBreakdown": "({{cards}} 张卡片 · {{gaps}} 个 gap)",
    "selectedCount": "已选 {{selected}} / {{total}}",
    "whyPrefix": "原因:"
  },
  "documents": {
    "cardCount": "{{count}} 张卡片",
    "confirmDelete": "删除「{{title}}」？此操作无法撤销。",
    "emptyBody": "在左侧选择一个模板，从你的卡片生成一份新文档。已保存的文档会再次出现在此列表中；当来源卡片变更时我们会把它标记为已过期，提示你重新生成。",
    "emptyList": "暂无已保存的文档。从上方选择一个模板来生成。",
    "emptyTitle": "长文档都在这里。",
    "errDelete": "删除失败: {{message}}",
    "heading": "文档",
    "newFromTemplate": "+ 从模板新建",
    "regenerate": "重新生成",
    "savedCount": "已保存 {{count}} 个",
    "stale": "已过期",
    "staleBanner": "自本文档生成以来，一张或多张来源卡片已发生变更。",
    "templatesToggle": "▴ 模板",
    "share": "分享",
    "shareCopied": "链接已复制"
  },
  "frame": {
    "acceptAndUse": "采纳并使用",
    "designSectionHeading": "从你的卡片设计一个视图",
    "designingBody": "正在读取你的卡片，并基于你实际写下的内容构建拓扑结构。已用时 {{seconds}} 秒。",
    "designingCardCount": "{{count}} 张卡片",
    "designingTopology": "正在设计拓扑",
    "errCloneFailed": "克隆失败: {{message}}",
    "errLoadTemplates": "加载模板失败: {{message}}",
    "errSaveFailed": "保存失败: {{message}}",
    "errSuggestFailed": "建议失败: {{message}}",
    "haveAgentDesign": "让 agent 设计一个",
    "headingAdd": "添加视图",
    "headingSuggested": "建议的视图",
    "meceTag": "[MECE]",
    "nodeCount": "{{count}} 个节点",
    "orPickTemplate": "或选择一个模板",
    "proposedTopology": "建议的拓扑 · {{nodes}} 个节点 · 源自 {{cards}} 张卡片",
    "recommendedByPack": "★ 由 {{pack}} 包推荐",
    "saving": "保存中",
    "suggestNeedMore": "至少需要 6 张卡片(你目前有 {{count}} 张)。继续对话后再试。",
    "suggestReady": "读取你的 {{count}} 张卡片，并基于你实际写下的内容提出一套拓扑结构。约 10–30 秒。"
  },
  "gaps": {
    "answer": "解答",
    "answerTitle": "打开一个对话，与 agent 一起解答这个问题",
    "approveTitleCard": "作为 {{kind}} 加入(进入卡片栏)",
    "approveTitleQuestion": "作为问题加入待解问题",
    "approveToCards": "加入卡片",
    "approveToOpen": "加入 OPEN",
    "archive": "归档",
    "archiveTitle": "软隐藏这个问题 — wikilink 仍可解析",
    "auditButton": "+ 审查",
    "auditGapsButton": "+ 审查 gap",
    "auditInProgress": "审查进行中…",
    "auditNeedsThread": "请先打开或新建一个对话",
    "auditTitle": "运行项目级 gap 审查 — 把具体 gap 展开到 OPEN",
    "auditingBusy": "审查中…",
    "blocksLabel": "阻塞:",
    "citedLabel": "引用:",
    "citedTitle": "悬停高亮被引用的发言；点击发言编号可跳转",
    "collapse": "收起",
    "discuss": "讨论",
    "discussTitle": "把这个 gap 钉到讨论区，一起解决",
    "dismiss": "驳回",
    "dismissTitle": "驳回 — 删除该提案并把 blocks 标记为已驳回",
    "emptyState": "暂无待办。当 agent 标记未知项、提议卡片，或你运行审查时，相关项会出现在这里。",
    "expand": "展开",
    "frameLabel": "视图",
    "heading": "OPEN",
    "hidePanel": "隐藏 OPEN 面板",
    "jumpTo": "跳转到 {{id}}",
    "jumpToTurn": "跳转到对话中的 {{turn}}",
    "nodeEmpty": "{{label}} 为空",
    "openCard": "打开这张卡片",
    "openProbeCount": "打开 {{count}} 个探查问题",
    "openProbePopover": "打开探查弹窗",
    "priorityNone": "未分类",
    "priorityP0": "P0 — 阻断项",
    "priorityP1": "P1 — 子系统",
    "priorityP2": "P2 — 打磨",
    "priorityP3": "P3 — 基础设施 / 运维",
    "questionLabel": "问题",
    "railExpand": "展开 OPEN 面板",
    "railExpandCount": "{{count}} 个待办项 — 点击展开",
    "refsLabel": "引用资料:",
    "sectionFrameGaps": "视图 gap",
    "sectionOpenQuestions": "待解问题",
    "sectionPendingReview": "待审提案",
    "sectionStaleRipple": "过期波及",
    "untitled": "(无标题)",
    "untitledProposal": "(无标题提案)",
    "untitledQuestion": "(无标题问题)",
    "whyPrefix": "原因:"
  },
  "generate": {
    "copied": "已复制 ✓",
    "copyMarkdown": "复制 markdown",
    "copyTitle": "复制 markdown 到剪贴板",
    "downloadMd": "下载 .md",
    "downloadTitle": "下载为 .md",
    "fromCards": "来自 {{count}} 张卡片",
    "heading": "已生成 · {{template}}",
    "saveFailed": "保存失败: {{message}}",
    "saveTitle": "把文档保存到项目",
    "saved": "已保存 ✓",
    "savedTitle": "文档已保存",
    "saving": "保存中…",
    "streaming": "生成中…",
    "titlePlaceholder": "文档标题…",
    "viewRaw": "源码",
    "viewRendered": "渲染视图",
    "waitStreaming": "请等待生成完成"
  },
  "history": {
    "byAgent": "由 agent",
    "byFs": "由文件系统",
    "byYou": "由你",
    "closeAria": "关闭历史",
    "current": "当前",
    "daysAgo": "{{count}} 天前",
    "diffNoPrior": "差异（无前一修订）",
    "diffVsRev": "与修订 {{rev}} 的差异",
    "fieldBody": "正文",
    "fieldKind": "种类",
    "fieldPack": "包",
    "fieldTitle": "标题",
    "filterFs": "文件系统",
    "filterFsTooltip": "显示文件系统编辑（vim、Obsidian、git pull）",
    "filterMetadata": "元数据",
    "filterMetadataTooltip": "显示仅 extra/元数据变更的修订（例如 dismissed_gaps）",
    "hiddenCount": "已隐藏 {{count}} 个",
    "noMatch": "没有修订符合当前筛选条件",
    "none": "（无）",
    "opDelete": "删除",
    "opFs": "文件系统",
    "opPatch": "修补",
    "opPromote": "提升",
    "opWrite": "写入",
    "restore": "恢复",
    "restoreConfirm": "恢复",
    "restoreMessage": "{{cardId}} 的当前正文将被此修订的内容覆盖。恢复本身会记录为一个新修订——不会丢失任何内容，但该变更会显示在历史中。",
    "restoreTitle": "恢复修订 {{rev}}？",
    "restoreTooltip": "将此修订恢复为当前正文",
    "restoring": "恢复中…",
    "revCount_one": "{{count}} 个修订",
    "revCount_other": "{{count}} 个修订",
    "revLabel": "修订 {{rev}}",
    "snapshot": "快照",
    "startsHere": "历史从这里开始",
    "title": "历史",
    "undeleteConfirm": "撤销删除",
    "undeleteMessage": "卡片将依据此修订的内容重新创建。该恢复会记录为一个新修订，因此删除事件会保留在历史中。",
    "undeleteTitle": "撤销删除 {{cardId}}？",
    "yesterday": "昨天"
  },
  "homepage": {
    "ccBullet1Body": "· 外加对话与文档读取器。写入被锁定在 fact / statement / question——decision 始终归你。",
    "ccBullet1Label": "MCP · 读取",
    "ccBullet1Title": "五个读取工具，一个安全写入",
    "ccBullet2BodyPart1": "构建过程中的发现会以 gap 卡片的形式回传，并标注",
    "ccBullet2BodyPart2": "。你在台账里分诊；CLI 绝不会替你敲定 decision。",
    "ccBullet2Label": "CLI · 提议",
    "ccBullet2Title": "flag · fact · mark-built",
    "ccBullet3BodyPart1": "一旦某张卡片被标记为",
    "ccBullet3BodyPart2": "，对其正文的编辑就会触发漂移标志位。界面会显示出需求已变、而代码未跟上的地方。",
    "ccBullet3Label": "漂移检测",
    "ccBullet3Title": "需求 ↔ 代码自动标记",
    "ccHeadingLine1": "卡片作为环境上下文。",
    "ccHeadingLine2": "发现作为 gap 提议。",
    "ccIntroPart1": "Draftlize 以一个",
    "ccIntroPart2": "（独立的",
    "ccIntroPart3": "二进制程序）以及一个",
    "ccIntroPart4": "的形态交付，把卡片镜像进你的代码库。Claude Code、Cursor 和 vim 把它们当作环境上下文来读；发现则以 gap 提议的形式回流，交由你来分诊。",
    "ccIntroStrong1": "MCP 服务器",
    "ccIntroStrong2": "CLI",
    "ccLabel": "图 5 · 外部 AGENT",
    "compareColChatGPT": "ChatGPT / Claude",
    "compareColDraftlize": "Draftlize",
    "compareColLinear": "Linear Docs",
    "compareColNotion": "Notion AI",
    "compareHeading": "为产品思考而做，",
    "compareHeadingEm": "不是泛用笔记。",
    "compareIntro": "泛用笔记 app 是为静态文档建的。ChatGPT 是为无状态对话建的。Draftlize 是第一个让你的产品决策在对话、agent、sprint 之间复利的 substrate。",
    "compareLabel": "为什么是 Draftlize",
    "compareLegendNo": "—",
    "compareLegendPartial": "部分支持",
    "compareLegendYes": "原生支持",
    "compareRow1": "跨对话保留 context",
    "compareRow2": "改 spec 自动标记依赖 stale",
    "compareRow3": "决策是可寻址的，不是埋在散文里",
    "compareRow4": "跨 thread 冲突检测",
    "compareRow5": "Claude Code / Cursor / MCP 一等 context",
    "compareRow6": "卡片级历史 + 来源（谁决定的、何时、为什么）",
    "compareRow7": "任意时刻导出完整图谱为 markdown",
    "demoAriaLabel": "stale 传播演示",
    "demoButtonIdle": "重写 c-04 →",
    "demoButtonReset": "重置 ↻",
    "demoButtonWriting": "写入中…",
    "demoByYou": "由你创建",
    "demoCardDecision": "魔法体系：{{value}}",
    "demoCardDecisionPrefix": "魔法体系：",
    "demoCardQuestion": "解锁第二个槽位后，界面如何呈现属性切换？",
    "demoCardStatement1": "Boss「Pyrhad」弱点——水属性爆发伤害决定了战斗节奏",
    "demoCardStatement2": "第 3 关的隐藏路线至少需要一名土属性角色",
    "demoNarrateIdle": "改动一个 decision · 看依赖项被标记为 stale",
    "doc1Bul1": "免费档 0.1 倍额度，推动 Pro 转化",
    "doc1Bul2": "Max 档可能蚕食自托管路径",
    "doc1Cards": "14 张卡片",
    "doc1Hdg1": "## 背景",
    "doc1Hdg2": "## 决策",
    "doc1Hdg3": "## 取舍",
    "doc1Hdg4": "## 待解",
    "doc1Row1": "目标：独立咖啡馆店主，25 美元工具预算上限",
    "doc1Row2": "预付费钱包 · 按量付费 · 注册送 $5",
    "doc1Row3": "重度用量用户画像",
    "doc1Stale": "2 张 STALE",
    "doc2Cards": "9 张卡片",
    "doc2Hdg1": "1 · 问题",
    "doc2Hdg2": "2 · 机制",
    "doc2Hdg3": "3 · 演示",
    "doc2Hdg4": "4 · 市场",
    "doc2Hdg5": "5 · 商业模式",
    "doc2Row1": "AI 对话在第 30 轮后开始衰退",
    "doc2Row2": "卡片图谱 + stale 传播",
    "doc2Row3": "UC-01 主流程",
    "doc2Row4": "AI 原生的从业者",
    "doc2Row5": "预付费钱包",
    "doc3Body1Em": "论证不再深入",
    "doc3Body1Part1": "到了第三十轮，大多数人都会发现同一件事：",
    "doc3Body1Part2": "而开始变薄。模型没坏——缺的是承载思考的成果……",
    "doc3Body2Em": "decision",
    "doc3Body2Part1": "重写一张",
    "doc3Body2Part2": "卡片。每一个依赖它的想法都被标记为 stale，打上删除线，染成琥珀色……",
    "doc3Cards": "6 张卡片",
    "doc3Hdg1": "为何选择 Draftlize",
    "doc3Hdg2": "机制",
    "doc3Stale": "1 张 STALE",
    "doc4Bul1": "愿景 · 一句话定位",
    "doc4Bul2": "存在的理由（两个信念）",
    "doc4Bul3": "└ 要成果，而非笔记",
    "doc4Bul4": "└ 思考本身就是协作",
    "doc4Bul5": "从 v3 沿用下来的部分",
    "doc4Bul6": "优势——以 PG 为单一事实源",
    "doc4Bul7": "成功标准（5 项）",
    "doc4Cards": "22 张卡片",
    "docClean": "无 STALE",
    "docTemplate1Label": "模板 01",
    "docTemplate2Label": "模板 02",
    "docTemplate3Label": "模板 03",
    "docTemplate4Label": "模板 04",
    "docsHeadingLine1": "生成草稿。",
    "docsHeadingLine2": "卡片才是事实之源。",
    "docsIntroEm": "派生视图",
    "docsIntroPart1": "文档是",
    "docsIntroPart2": "。每一行都存有模板 + markdown +",
    "docsIntroPart3": "。当被引用的卡片变更时，后台检测器会通过 SSE 推送",
    "docsIntroPart4": "——源头一旦漂移，琥珀色圆点便随即亮起。",
    "docsLabel": "图 4 · 长文输出",
    "edition": "第 1 卷 · 2026 年版",
    "faq1AnswerPart1": "不需要——Draftlize 是预付费的，所以没有什么需要取消。注册即得 $5 额度，之后只为用掉的部分付费。你的余额",
    "faq1AnswerPart2": "永不过期，你随时可以导出全部内容。",
    "faq1Question": "需要订阅吗？",
    "faq2Answer": "随时。所有 card、thread、document、history、ref 文件完整 markdown 导出。纯文本——无锁定、无私有格式。你可以带去 Obsidian、Notion、vim、或者任何地方。",
    "faq2Question": "可以导出我的数据吗？",
    "faq3Answer": "你的卡片始终是你的。我们绝不用你的数据训练模型。Server 在 Fly.io 跑无状态容器；数据在你 tenant 隔离的 Postgres + Tigris S3 里。完整数据删除请求在 7 天内执行。",
    "faq3Question": "隐私 / 数据所有权怎么处理？",
    "faq4Answer": "把现有的 markdown / PDF / 文档拖到 _refs/ 面板，agent 会从中抽取卡片。暂时没有一键导入——但 agent 能读你给它的任何东西，逐张提议卡片给你 Approve / Reject。多数 PM 报告 30-60 分钟就能从现有文档孵化出一个可用项目。",
    "faq4Question": "从 Notion / Linear / 一堆文档迁移过来怎么办？",
    "faq5Answer": "没有套餐分档，也没有硬上限——用量随你工作从钱包余额里扣。余额快用完时，随时在 设置 → 账单 里充值，$5 起，额度即时到账，所以你绝不会在心流中途被卡住。没花掉的留在钱包里，永不过期。",
    "faq5Question": "有用量上限吗？",
    "faqHeading": "常见问题",
    "finalBody": "把你的产品思考放进一个 AI agent 既能读、也能写的 substrate 里。$5 免费额度起步，按量付费，余额永不过期。",
    "finalCta": "凭邀请码进入",
    "finalHeadingLine1": "别再丢失思考成果。",
    "finalHeadingLine2": "开始把它留住。",
    "footerAriaGitHub": "使用 GitHub 登录",
    "footerAriaGoogle": "使用 Google 登录",
    "footerAriaMagicLink": "通过邮箱魔法链接登录",
    "footerBlurb": "一个 agent 原生的想法孵化器。构建于自托管的 Rust agent、Postgres + pgvector 以及 S3 支持的引用之上。闭源 SaaS——你的数据随时可导出为 markdown。",
    "footerContact": "联系我们",
    "footerEdition": "第 1 卷 · 第 1 期 · 全球抢先体验 · 2026 年版",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerLanguage": "语言",
    "footerLanguageNote": "可按对话单独覆盖",
    "footerMagicLink": "魔法链接",
    "footerPrivacy": "隐私政策",
    "footerSignIn": "登录",
    "footerTerms": "服务条款",
    "founderBody": "每开一个新的 Claude 对话，我都要重新解释为什么我们砍掉了 freemium 模型、onboarding 决定是什么、为什么选 Stripe 而不是 Lemon。第三个 sprint 时我意识到——我没在做产品工作，我在做 context 找回工作。于是我做了一个 AI 能读、也能写的决策 substrate，而不是只能看到 chat 历史。Draftlize 是我每天在用的东西。如果你是一个住在 AI 对话里、每周一半时间花在反复解释的 PM，你就是我做这个产品的对象。",
    "founderHeading": "一个受够了反复",
    "founderHeadingEm": "解释 context 的 PM。",
    "founderLabel": "为什么做这个",
    "founderSig": "— Draftlize 创始人",
    "gainLabel": "收益",
    "heroCtaReadMechanic": "了解机制",
    "heroCtaStartFree": "凭邀请码进入",
    "heroLabel": "限量内测 · 邀请制",
    "heroLedePart1": "为产品经理和产品设计师而做。每个 spec、决策、推理都成为一张",
    "heroLedePart2": "。改一个 spec——所有依赖它的 thread 都会被",
    "heroLedePart3": "。决策不再每个 sprint 被反复推翻。",
    "heroLedeStrong1": "可寻址的卡片",
    "heroLedeStrong2": "自动标记 stale",
    "heroRoiLine": "产品经理每周浪费 5+ 小时给 AI 反复解释 context。Draftlize 把它留住。",
    "heroStack1": "自托管 RUST AGENT",
    "heroStack2": "POSTGRES + PGVECTOR",
    "heroStack3": "MCP + CLI · 适配 CLAUDE CODE",
    "heroTitleLine1": "与 agent 一起思考。",
    "heroTitleLine2": "留下思考成果。",
    "mechanic1BodyPart1": "每张卡片都是一个结构化的原子——",
    "mechanic1BodyPart2": " Wikilink 连出关系边。没有「主文档 + 附件」的二元割裂。",
    "mechanic1Title": "卡片图谱就是文档本身。",
    "mechanic2BodyPart1": "重写一个",
    "mechanic2BodyPart2": "→ 底座沿着",
    "mechanic2BodyPart3": "反向回溯 → 每一个传递依赖项都被置为",
    "mechanic2BodyPart4": "界面打上删除线，亮起琥珀色标记。",
    "mechanic2Title": "stale 传播是头等行为。",
    "mechanic3BodyPart1": "当 agent 拿不准时，",
    "mechanic3BodyPart2": "会放下一张",
    "mechanic3BodyPart3": "。始终可见，无法折叠。批准 · 讨论 · 驳回。",
    "mechanic3Title": "gap 台账常驻第四栏。",
    "mechanic4BodyPart1": "在一个项目里开启多个对话——它们共享卡片，但不共享聊天记录。后台检测器会把跨对话的矛盾归档为",
    "mechanic4Title": "多对话并行，自动检测冲突。",
    "mechanicHeadingLine1": "四个动作",
    "mechanicHeadingLine2": "让它不只是一个笔记应用。",
    "mechanicLabel": "图 1 · 核心机制",
    "mockCardDecision": "预付费钱包 · 按量付费 · 余额永不过期",
    "mockCardGap": "market-research/c-31 称预算为 35–50 美元——与 c-09 冲突",
    "mockCardStatement1": "独立咖啡馆店主每月工具预算约 25 美元上限——按量付费适配任何预算",
    "mockCardStatement2": "注册送 $5 额度，让用户先试用、再充值",
    "mockCards": "卡片",
    "mockGapConflict": "预算数字在多个对话间存在冲突",
    "mockGapInterp1": "「独立咖啡馆」——是否包含小型连锁？",
    "mockGapInterp2": "重度用量用户画像尚未定义",
    "mockGapLedger": "GAP 台账",
    "mockThreads": "对话",
    "navDocuments": "文档",
    "navEarlyAccess": "抢先体验 →",
    "navMechanic": "机制",
    "navPeople": "用户",
    "navPricing": "定价",
    "navProblem": "问题",
    "painLabel": "痛点",
    "persona1Gain": "卡片就是持久记忆。开新 thread，agent 把 c-04（定价决策）和 c-09（目标人群）作为 ambient context 读入。重复解释降到零。改 spec 时所有依赖 thread 自动标记 stale，决策不再漂移。",
    "persona1Name": "产品经理",
    "persona1Pain": "每开一个新对话都要重新讨论几周前定好的定价、目标人群、onboarding 决策。周五一看花了 8 小时在重复解释第 2 周就敲定的 context。",
    "persona1Role": "Mira —— A 轮 SaaS 高级 PM，用 Claude 当思考拍档跑 roadmap",
    "persona1Snippet": "\"把 AI 辅助 PM 工作时间从每周 12 小时砍到 6 小时。同样的产出，少一半的重复解释。\"",
    "persona1SnippetLabel": "来自 dogfood · 第 4 周",
    "persona1Tag": "№ 01 · 产品经理",
    "persona2GainPart1": "每个设计决策都是一张卡。agent 先读 c-03（颜色原则）和 c-22（组件锁定理由）再提改动建议。跨面冲突在 PR 开起来前就以",
    "persona2GainPart2": "形式浮现。",
    "persona2Name": "产品设计师",
    "persona2Pain": "设计原则、系统 token、组件背景理由散在 3 份 Figma、2 份 Notion 和 47 条 Loom 录像里。AI 设计对话下个 sprint 就忘了他为什么选 sentence case 而不是 title case。",
    "persona2Role": "Diego —— 金融科技 staff 产品设计师，负责设计系统 + 4 个产品面",
    "persona2Snippet": "\"5 秒内捕到跨 3 个面的 sentence case 违规。以前每次设计 review 前要花 30 分钟手动检。\"",
    "persona2SnippetLabel": "来自 dogfood · 第 6 周",
    "persona2Tag": "№ 02 · 产品设计师",
    "personasHeadingLine1": "两种角色。",
    "personasHeadingLine2Em": "context 蒸发",
    "personasHeadingLine2Part1": "两个让",
    "personasHeadingLine2Part2": "变得昂贵的瞬间。",
    "personasIntro": "当一个产品调整会连锁导致重写所有依赖决策时，Draftlize 才真正发挥价值。PM 和产品设计师对此感受最深——因为他们的思考本身就是交付物。",
    "personasLabel": "图 2 · 谁需要 Draftlize",
    "pricingTrust1": "注册送 $5",
    "pricingTrust2": "随时导出数据",
    "pricingTrust3": "无锁定 · 随时导出",
    "problem1Body": "你第 3 周定了定价。第 7 周，在新对话里，你和 agent 又把同一个 trade-off 从头吵一遍——因为聊天记录里没有任何可寻址的东西。",
    "problem1Num": "I",
    "problem1Title": "决策每个 sprint 都被反复讨论",
    "problem2Body": "你改一个假设——onboarding 流程、目标人群、定价档位——所有依赖它的文档都在悄悄烂掉。demo 当天才发现是哪份。",
    "problem2Num": "II",
    "problem2Title": "Spec 悄悄漂移没人发觉",
    "problem3Body": "新对话，新失忆。你第五次解释\"为什么我们否决了 freemium 模型\"。本该复利的 context，没复利。",
    "problem3Num": "III",
    "problem3Title": "Agent 每次对话都把你忘干净",
    "problemHeading": "AI 辅助产品工作中悄悄发生的",
    "problemHeadingEm": "三个痛点。",
    "pullQuote": "你可以和 agent 思考一小时，却一无所获——除非这份成果会记住一切。",
    "pullQuoteCite": "摘自 Draftlize 内测日志 · 2026-02",
    "surfaceClaudeCitedBody": "预付费钱包 · 按量付费 · 余额永不过期",
    "surfaceClaudeReplyPrefix": "来自",
    "surfaceClaudeTitle": "C · CLAUDE CODE",
    "surfaceClaudeUserMsg": "那张定价卡片到底写了什么？",
    "surfaceClaudeWhoYou": "你",
    "surfaceWebCaption": "→ 带类型字形渲染，悬停预览 stale 图谱，拖拽可重排，点击展开完整历史抽屉",
    "surfaceWebCardBody": "预付费钱包 · 按量付费 · 余额永不过期",
    "surfaceWebCardMeta": "3 个依赖项 · 14 分钟前编辑 · 由你创建",
    "surfaceWebTitle": "A · 网页界面 · CardPeek",
    "surfacesHeadingEm": "成为一等 context。",
    "surfacesHeadingPart1": "两个面让你的卡片",
    "surfacesIntroPart1": "Draftlize web 应用 + Claude Code 集成。同一张卡，",
    "surfacesIntroPart2": "两边都可寻址。开发者完整的面集（CLI、MCP、原始 markdown）在下方开发者页。",
    "surfacesLabel": "图 3 · 你的卡片在哪",
    "testimonial1Quote": "我在周二改了魔法体系。到周三就清完了 20 张依赖卡片。要是没有 stale 传播，这本会是整整一个月的 bug 报告。",
    "testimonial1Role": "独立开发者 · roguelike",
    "testimonial2Quote": "在我发出备忘录之前，跨对话冲突检测抓出了两份生物科技报告之间的口径不一致。这种发现，你只有在它救过你一次声誉之后才会真正体会到它的价值。",
    "testimonial2Role": "调查记者",
    "testimonial3Quote": "把卡片作为 Claude Code 的环境上下文，是真正的杀手锏。agent 不再追问「你上周决定了什么」——因为上周就明明白白躺在代码库里。",
    "testimonial3Role": "独立黑客 · B2B 工具",
    "voicesHeadingEm": "以及大家常问的问题。",
    "voicesHeadingPart1": "内测用户怎么说。"
  },
  "import": {
    "changeFile": "点击或拖入另一个文件以更换",
    "dropZone": "把 draftlize 导出的 .zip 拖到这里",
    "dropZoneHint": "或点击选择文件",
    "errNotZip": "需要一个 .zip 文件，但收到的是 {{name}}",
    "heading": "导入项目",
    "importButton": "导入 →",
    "importing": "导入中…",
    "projectNameLabel": "项目名称(可选)",
    "projectNamePlaceholder": "留空则使用「<原名> (imported)」"
  },
  "login": {
    "codeHint": "或输入邮件中的 6 位验证码：",
    "codeInvalid": "验证码无效或已过期——请核对邮件或重新发送。",
    "codeSubmit": "登录",
    "emailPlaceholder": "you@example.com",
    "errorSendFailed": "发送失败。请重试，或改用 GitHub / Google。",
    "inviteInvalid": "邀请码无效或已被使用",
    "invitePlaceholder": "邀请码",
    "inviteRequired": "注册需要邀请码",
    "noInviteWaitlist": "没有邀请码？加入等待列表",
    "sendMagicLink": "发送魔法链接",
    "sending": "发送中…",
    "sentBodyPrefix": "我们已将登录链接发送至",
    "sentBodySuffix": "。链接 15 分钟后失效，且仅可使用一次。",
    "sentTitle": "请查收邮件",
    "separatorOr": "或",
    "signInWithGitHub": "使用 GitHub 登录",
    "signInWithGoogle": "使用 Google 登录",
    "tagline": "为思考而生的 agent",
    "useDifferentEmail": "换一个邮箱",
    "waitlistBack": "返回登录",
    "waitlistIntro": "Draftlize 正在限量内测。留下邮箱，开放名额时我们会把邀请码发给你。",
    "waitlistJoin": "加入等待列表",
    "waitlistJoinedBody": "名额开放时，邀请码会发送到你的邮箱。",
    "waitlistJoinedTitle": "已加入等待列表",
    "wechatHint": "请用邮箱登录——我们会发送登录链接到你的邮箱。"
  },
  "refs": {
    "attach": "附加",
    "attachTitle": "附加到当前消息",
    "confirmDelete": "删除引用资料「{{name}}」？",
    "dismissError": "点击关闭",
    "emptyState": "暂无引用资料 — 拖入文件或使用下方的上传",
    "errDelete": "删除失败: {{message}}",
    "errLoad": "加载引用资料失败: {{message}}",
    "errRead": "读取失败: {{message}}",
    "heading": "项目引用资料",
    "peekTitle": "预览内容",
    "sharedAcrossThreads": "跨对话共享",
    "uploadNew": "+ 上传新文件",
    "uploading": "上传中 {{count}}…"
  },
  "settings": {
    "adminBadge": "管理员",
    "adminTools": "管理工具",
    "adminToolsHint": "概览、LLM 用量、错误排查、用户。",
    "buildBinaryHint": "先构建二进制文件：<code>cargo build --release -p draftlize-mcp</code>",
    "copied": "✓ 已复制",
    "copy": "复制",
    "copyCommand": "复制命令",
    "copyToken": "复制令牌",
    "createToken": "创建令牌",
    "creating": "创建中…",
    "deleteConfirm": "永久删除“{{name}}”？卡片、对话和历史记录将全部消失。此操作无法撤销。",
    "deleteProject": "删除项目…",
    "deleting": "删除中…",
    "errClipboard": "写入剪贴板失败 —— 请手动选中文本并复制",
    "errCreateToken": "创建令牌：{{error}}",
    "errDelete": "删除：{{error}}",
    "errMcpToggle": "MCP 切换：{{error}}",
    "errRevokeToken": "撤销令牌：{{error}}",
    "errUpdatePack": "更新包：{{error}}",
    "heading": "设置",
    "integrationsBlurb": "让外部 AI 工具（Claude Code、Cursor、Claude Desktop）通过 <mcp>MCP</mcp> 读取此项目的卡片。只读 —— 它们无法通过此通道编辑卡片。",
    "wizardTitle": "接入 Claude Code",
    "wizardBlurb": "把这个项目的卡片同步进你的代码仓库，让 Claude Code（或任何 coding agent）与你共享同一份决策记忆——并把构建中的发现写回来。",
    "wizardStep1": "生成 API token",
    "wizardGenerate": "生成 token",
    "wizardHaveTokens_one": "已有 {{count}} 个有效 token——如果你保存过密钥可以直接复用，也可以为这台机器新建一个。",
    "wizardHaveTokens_other": "已有 {{count}} 个有效 token——如果你保存过密钥可以直接复用，也可以为这台机器新建一个。",
    "wizardStep2": "安装 CLI 并连接此项目",
    "wizardTokenPlaceholder": "<你的 dft_… token>",
    "wizardCopyAll": "复制全部 4 条命令",
    "wizardStep2Hint": "连本地 dev 服务器？先 export DRAFTLIZE_API_URL。",
    "wizardStep3": "连接状态",
    "wizardNoToken": "等待 token——先完成第 1 步。",
    "wizardWaiting": "等待第一次 CLI 调用……本页每 10 秒自动检测。",
    "wizardConnected": "已连接——token“{{name}}”{{time}}活跃。",
    "wizardIdle": "上次 CLI 活动在 {{time}}——跑一次 draftlize pull 即可重新连上。",
    "wizardTryNext": "已连接！下一步，在 Claude Code 里试试 <code>/draftlize:status</code>。",
    "wizardDevMcp": "本地 DEV · MCP SERVER（直连 POSTGRES）",
    "wizardDevMcpBlurb": "MCP stdio server 直连 Postgres——只有能访问数据库的环境（本地 dev）才能用。其他机器请走上面的 CLI 路径。",
    "inviteCopied": "已复制",
    "inviteCopy": "复制",
    "inviteRevoked": "已撤销",
    "inviteUsed": "已使用",
    "invitesEmpty": "还没有邀请码。使用 Draftlize 满一周、项目卡片超过 20 张后，3 个邀请码会出现在这里。",
    "invitesGrantedNow": "你刚刚获得了 3 个邀请码——感谢一路同行。把它们分享给爱琢磨事儿的朋友吧。",
    "invitesIntro": "Draftlize 正在限量内测——邀请码可以让朋友跳过等待列表。使用满一周且卡片满 20 张后，你会获得 3 个邀请码。",
    "invitesLoadFailed": "加载邀请码失败，请稍后重试。",
    "languageHint": "设置界面与 agent 回复的语言。卡片内容不会被翻译。",
    "languageLabel": "语言",
    "loading": "加载中…",
    "localeAuto": "自动（跟随浏览器）",
    "navAccount": "账户",
    "navBilling": "账单",
    "navGeneral": "通用",
    "navIntegrations": "集成",
    "navInvites": "邀请",
    "navTokens": "API 令牌",
    "noExternalReads": "暂无外部读取",
    "noProjectGeneral": "打开一个项目以访问通用设置。",
    "noProjectIntegrations": "打开一个项目以管理其 MCP 集成。",
    "noTokens": "暂无令牌",
    "oneTimeInstall": "一次性安装（在你的终端中）",
    "openAdminPanel": "打开管理面板",
    "packBlank": "空白",
    "pasteIntoShell": "粘贴到你的 shell 中：",
    "reallyDelete": "确认删除",
    "reallyRevoke": "确认撤销",
    "recentAccess": "最近访问",
    "relDays_one": "{{count}} 天前",
    "relDays_other": "{{count}} 天前",
    "relHours_one": "{{count}} 小时前",
    "relHours_other": "{{count}} 小时前",
    "relMinutes_one": "{{count}} 分钟前",
    "relMinutes_other": "{{count}} 分钟前",
    "relSeconds_one": "{{count}} 秒前",
    "relSeconds_other": "{{count}} 秒前",
    "relYesterday": "昨天",
    "renameHint": "在侧边栏重命名（双击）",
    "revoke": "撤销",
    "revoking": "撤销中…",
    "rowEmail": "邮箱",
    "rowGithub": "GitHub",
    "rowName": "名称",
    "rowPack": "包",
    "rowProjectId": "项目 ID",
    "rowStatus": "状态",
    "rowTenant": "租户",
    "savedDismiss": "我已保存 —— 关闭",
    "saving": "保存中…",
    "sectionIntegrations": "集成",
    "sectionProject": "项目",
    "sectionTokens": "API 令牌",
    "session": "会话",
    "signOut": "退出登录",
    "signedInAs": "当前登录",
    "signingOut": "退出中…",
    "statusConnected_one": "已连接 · 24 小时内 {{count}} 次读取",
    "statusConnected_other": "已连接 · 24 小时内 {{count}} 次读取",
    "statusDisabled": "已为此项目禁用",
    "statusSetUp": "已配置 · 暂无读取",
    "statusUnavailable": "不可用",
    "toggleDisable": "为此项目禁用 MCP",
    "toggleDisableTitle": "对 MCP 客户端隐藏此项目（已有读取仍会记录；新的读取将被拒绝）",
    "toggleEnable": "为此项目启用 MCP",
    "toggleEnableTitle": "重新向 MCP 客户端开放此项目",
    "tokenCreated": "创建于",
    "tokenCreatedNotice": "<name>{{name}}</name> —— 请立即复制。完整令牌仅显示一次，之后无法再次获取。",
    "tokenLastUsed": "最近使用 {{time}}",
    "tokenNamePlaceholder": "令牌名称（例如 laptop、ci-bot）",
    "tokenNeverUsed": "从未使用",
    "tokensBlurb": "用于 <code>draftlize</code> CLI 和外部 MCP 客户端的长效 bearer 令牌。每个令牌都以你的用户身份进行认证 —— 请像对待密码一样对待它们。",
    "unknownClient": "未知",
    "unverified": "未验证"
  },
  "sidebar": {
    "admin": "管理",
    "adminTitle": "管理 · 概览 / 用量 / 错误 / 用户",
    "archiveThread": "归档对话",
    "collapse": "折叠侧边栏",
    "create": "创建",
    "doubleClickRename": "双击以重命名",
    "expand": "展开侧边栏",
    "importFromZip": "从 .zip 导入",
    "mcpChipTitle": "MCP 集成 · 打开 设置 → 集成",
    "mcpChip_one": "⚡ MCP · {{count}} 次读取",
    "mcpChip_other": "⚡ MCP · {{count}} 次读取",
    "newEmptyProject": "+ 新建空白项目",
    "newMenu": "+ 新建",
    "newThread": "+ 新建",
    "noThreads": "暂无对话 —— 开始一个吧",
    "openAccount": "打开账户",
    "openAccountAria": "打开账户设置",
    "openAccountTitle": "{{identity}} —— 打开账户",
    "projectNamePlaceholder": "项目名称…",
    "projects": "项目",
    "settings": "设置",
    "tagline": "思考的 agent",
    "threads": "对话",
    "untitled": "无标题"
  },
  "tips": {
    "cardShortcuts": "打开卡片后，n 新建 · e 编辑 · esc 关闭",
    "dragFile": "把文件拖到输入框，即可作为项目参考附加",
    "editHistory": "卡片保留完整编辑历史 — 打开卡片并点开历史抽屉",
    "exportProject": "点击卡片栏底部的“N 张卡片”可下载整个项目",
    "hideTips": "隐藏提示",
    "importZip": "侧栏的 + NEW ▾ 也可导入 draftlize 的 .zip 导出文件",
    "newline": "⇧↵ 换行 · ↵ 发送",
    "nextTip": "下一条提示",
    "projectRefs": "📎 列出项目参考 — 可附加、预览、上传或删除",
    "renameDoubleClick": "双击任意项目或对话名称即可重命名",
    "settings": "⚙ 设置（侧栏底部）可切换包或删除项目"
  },
  "usage": {
    "autoCompactionAt": "在 {{tokens}}（{{pct}}%）时自动压缩",
    "breakdownNextTurn": "明细（下一轮）",
    "cacheRead": "缓存读取",
    "cacheWrite": "缓存写入",
    "chipTitle": "上下文：{{input}} / {{window}}（{{pct}}%）—— 点击查看详情",
    "compactedThisTurn_one": "📦 本轮已压缩 {{count}} 条消息",
    "compactedThisTurn_other": "📦 本轮已压缩 {{count}} 条消息",
    "compactionActive": "自动压缩已启用",
    "compactionActiveBody_one": "{{count}} 条较旧的消息会被结构化摘要替换，以使 LLM 保持在输入预算之内。完整历史仍保留在对话中 —— 只有 LLM 看到的视图被裁剪。",
    "compactionActiveBody_other": "{{count}} 条较旧的消息会被结构化摘要替换，以使 LLM 保持在输入预算之内。完整历史仍保留在对话中 —— 只有 LLM 看到的视图被裁剪。",
    "compactionActiveLabel": "📦 压缩已启用：",
    "compactionHint": "自动压缩会在橙色刻度线（{{tokens}}）处触发。较旧的消息会被结构化摘要替换；完整历史仍保留在对话中。",
    "contextWindow": "上下文窗口",
    "freeSpace": "剩余空间",
    "input": "输入",
    "messages": "消息",
    "messagesCompacted_one": "消息（已压缩 {{count}} 条）",
    "messagesCompacted_other": "消息（已压缩 {{count}} 条）",
    "mobileChipAria": "上下文窗口 {{pct}}% —— 点按查看详情",
    "mobileSheetAria": "上下文窗口详情",
    "mobileSheetTitle": "上下文 · {{input}} / {{window}}（{{pct}}%）",
    "output": "输出",
    "sessionTotals": "会话总计（提供方）",
    "systemPrompt": "系统提示词",
    "toolsSchema": "工具 schema",
    "withoutCompaction": "未压缩时"
  },
  "marketing": {
    "footerProduct": "产品",
    "navForDevelopers": "开发者",
    "navForPm": "产品经理",
    "navHome": "首页",
    "navOpenApp": "打开应用 →",
    "navStart": "免费开始 →",
    "navPricing": "定价"
  },
  "pricing": {
    "heroLabel": "定价",
    "prepaidHeroTitle": "预付费。你只为",
    "prepaidHeroTitleEm": "用掉的部分付费——别无其他。",
    "prepaidLede": "没有订阅，没有套餐，没有月度账单。注册即得 $5 额度起步，之后只为你真正消耗的 AI 用量付费。随时充值，$5 起——没花掉的留在钱包里，永不过期。",
    "prepaidHeroCta": "领 $5 免费额度开始",
    "pointsHeadingPart1": "三件事，让它始终",
    "pointsHeadingEm": "诚实。",
    "pointsSubhead": "按 token 计量，单价公开统一。没有席位，没有套餐，没有意料之外的账单。",
    "point1Title": "免费起步",
    "point1Tag": "注册即送额度",
    "point1Body": "每个新账号都拿到 $5，想怎么花就怎么花——开始时无需绑卡。足够你跑一个真实项目、在掏钱之前先把闭环跑顺。",
    "point2Title": "按量付费",
    "point2Tag": "按 token 计量",
    "point2Body": "免费额度用完后，$5 起充值，继续往下走。你只为真正用掉的 token 付费，单价统一——绝不为席位、或一个迟早会被你用超的套餐买单。",
    "point3Title": "永不过期",
    "point3Tag": "余额始终是你的",
    "point3Body": "买到手的额度不会在月底清零。歇一个季度再回来，余额还是你离开时的那个数。没有续费，也没有什么需要取消。",
    "qaPrepaid1Q": "计费到底是怎么算的？",
    "qaPrepaid1A": "每次 AI 请求都有一个以美分计的 token 成本，随你工作从钱包里扣。你以 $5 免费额度起步；快用完时，$5 起充值。没有订阅，没有月费——你只为用量付费，别无其他。",
    "qaPrepaid2Q": "开始时需要绑信用卡吗？",
    "qaPrepaid2A": "不需要。注册那一刻 $5 起步额度就在账上。只有当你想充值更多时才需要加卡——而且那是一次性扣款，不是周期性订阅。",
    "qaPrepaid3Q": "余额用完了会怎样？",
    "qaPrepaid3A": "请求会暂停而不是报错，所以你永远不会被意外扣费。在 设置 → 账单 里 $5 起充值，额度即时到账——从你停下的地方接着干。",
    "qaPrepaid4Q": "我的额度会过期吗？",
    "qaPrepaid4A": "永远不会。你充进去的额度无限期留在钱包里。用得多的月份、清闲的月份——余额都会结转，没有续费，也没有什么要取消。",
    "qaPrepaid5Q": "还有月度方案或套餐分档吗？",
    "qaPrepaid5A": "没有——旧的 Pro / Power / Max 分档已经退役。每个人都拿到完整的 Draftlize，按同一个 token 单价付费。唯一不同的，只是你用了多少。",
    "prepaidFinalBody": "$5 免费额度起步，只为用掉的部分付费，没花的一分不少地留着。这就是全部的模式。",
    "pageDescription": "没有订阅，没有套餐。注册即得 $5 免费额度，只为你在完整 Draftlize 里用掉的部分付费：卡片图、stale 传播、跨 thread 冲突检测、Claude Code + MCP 集成。余额永不过期。",
    "pageTitle": "定价 · Draftlize — 按量付费，$5 免费起步",
    "qaHeading": "定价相关问题"
  },
  "forPm": {
    "ctaBody": "$5 免费额度起步，之后只为用掉的部分付费——没有订阅，余额永不过期。多数 PM 在第一周就看到自己重复解释的时间砍掉 50%。",
    "ctaButton": "立即开始",
    "ctaTitle": "Draftlize 全部能力。",
    "ctaTitleEm": "按量付费。",
    "heroLabel": "产品经理",
    "heroLede": "你已经把产品思考搬进了 AI 对话。现在该停止丢失它了。Draftlize 把每个决策、依赖、推理都做成 agent 既能读、也能写的可寻址卡片——context 在 sprint 之间复利，而不是蒸发。",
    "heroTitle": "给跟 AI 思考拍档",
    "heroTitleEm": "一起跑 roadmap 的 PM。",
    "pageDescription": "一个给 PM 跟 AI agent 一起跑 roadmap 的工作台。每个 spec、决策、推理都是可寻址的卡片。改一个 spec——所有依赖它的 thread 自动标记 stale。把 AI 辅助 PM 时间砍 ~50%。",
    "pageTitle": "产品经理 · Draftlize — 别再给 AI 反复解释 context",
    "scenario1Body": "你第 3 周敲定了定价模型。第 7 周，在新对话里，agent 把 c-04（定价决策）作为 ambient context 读入——从那里继续。不需要重新解释你已经做过的分析。",
    "scenario1Title": "定价决策不再被反复推翻",
    "scenario2Body": "你改了 onboarding 流程（c-12）。所有依赖 c-12 的 PRD 段落、design doc、Claude 对话自动标记 stale。到 demo 当天，你已经把漂移扫干净了。",
    "scenario2Title": "Spec 不再悄悄漂移",
    "scenario3Body": "Thread A 你说\"目标 SMB\"。Thread B（一周后）你说\"目标中端\"。Draftlize 的冲突检测器把这个标成 gap_kind=conflict 卡片。你在 ship 任何一个之前都能同时看到两者。",
    "scenario3Title": "跨 thread 冲突以 gap 形式浮现"
  },
  "forDevelopers": {
    "ctaBody": "$5 免费额度起步，之后只为用掉的部分付费——没有订阅，余额永不过期。完整 CLI + MCP + slash command，全部包含。",
    "ctaButton": "立即开始",
    "ctaTitle": "卡片就是代码 context。",
    "ctaTitleEm": "Spec 不再 drift。",
    "heroLabel": "开发者",
    "heroLede": "Draftlize 卡片是 substrate。CLI 把它们镜像到你的 repo 里作为 markdown。MCP server 把它们暴露给 Claude Code / Cursor / Claude Desktop 作为一等 context。实现 c-12 时标记 built——spec 改动时，状态自动翻转 drift_detected，你知道哪些要重访。",
    "heroTitle": "你的决策，",
    "heroTitleEm": "在你用的每个 AI 工具里可寻址。",
    "pageDescription": "Draftlize 给 spec 驱动开发用 AI agent。CLI 镜像卡片到你的 repo。MCP server 让卡片成为 Claude Code / Cursor / Claude Desktop 的一等资源。改 spec 后实现状态自动翻转 drift_detected。",
    "pageTitle": "开发者 · Draftlize — Claude Code / Cursor / MCP 的一等 context",
    "surface1Body": "卡片落到 `.draftlize/cards/<id>.md`，带 YAML frontmatter 的纯 markdown。Claude Code 当 ambient context 读。`draftlize flag c-7 \"...\"` 写一个 gap 卡回 GapLedger 等用户裁决。",
    "surface1Title": "CLI —— `draftlize pull` 到你的 repo",
    "surface2Body": "独立 binary `draftlize-mcp` 通过 stdio 跑 JSON-RPC。工具：`read_card` / `list_cards` / `search_cards` / `propose_card`（锁死到 fact/statement/question）。URI：`draftlize://<slug>/<cid>` 通过 `/api/resolve` 解析。",
    "surface2Title": "MCP server —— stdio JSON-RPC",
    "surface3Body": "`draftlize link <project>` 之后，四个 slash command 落到 `.claude/skills/draftlize/`：`/draftlize:cite` / `/draftlize:flag` / `/draftlize:fact` / `/draftlize:status`。Claude Code 直接解析。",
    "surface3Title": "Slash command —— `/draftlize:cite c-7`",
    "surface4Body": "`draftlize mark-built c-12` 把卡片状态翻成 `built`。之后改这张卡，状态自动翻 `drift_detected`——agent 知道哪些实现自哪个 snapshot、哪些自此变了。",
    "surface4Title": "implementation_status —— spec drift 追踪"
  },
  "share": {
    "footerCta": "试试 Draftlize",
    "footerTagline": "和 agent 一起孵化你的想法",
    "goneBody": "分享可能已被创建者撤销。",
    "goneTitle": "该链接已失效",
    "graphStats": "{{cards}} 张卡片 · {{edges}} 条关联"
  },
  "feedback": {
    "body": "扫码加入微信群——直接和开发者交流，第一时间拿到新功能和邀请码。",
    "fab": "早期用户群",
    "qrAlt": "微信群二维码",
    "qrFallback": "群二维码即将就位——先找邀请你的朋友拉你进群。",
    "title": "加入早期用户群"
  },
  "onboarding": {
    "beat1Body": "没有指令、没有语法，直接说你在琢磨的事就行。",
    "beat1Title": "像和一位敏锐的同事聊天一样开口。",
    "beat2Body": "当一个决定、事实或问题成形时，agent 会把它写进右侧的卡片面板——你可以编辑、关联、永久保留。",
    "beat2Title": "关键想法会自动变成卡片。",
    "beat3Body": "编辑一张被其他卡片依赖的卡，Draftlize 会标出所有受影响的下游——让你的思考跨越数周仍然自洽。",
    "beat3Title": "改一个决定，依赖它的结论自动标记待检视。",
    "kicker": "欢迎来到 DRAFTLIZE",
    "skip": "我自己开始",
    "starter1Label": "孵化一个产品想法",
    "starter1Prompt": "我在琢磨做一个产品。帮我想清楚核心想法、目标用户是谁、以及最有风险的假设是什么。",
    "starter2Label": "规划一个功能",
    "starter2Prompt": "帮我把一个新功能想清楚。先问我一些澄清问题，然后我们把关键决定一路记下来。",
    "starter3Label": "想清楚一个决定",
    "starter3Prompt": "我有一个决定要做，想和你把它推演清楚。我们把选项和取舍摆出来。",
    "titleLine1": "和 agent 一起思考。",
    "titleLine2": "留下结构化的成果。",
    "tryOne": "选一个开始"
  }
}
